import { t } from "@/i18n-js/instance";
import { EventsListByMonth } from "@circle-react/components/AllEvents/EventsListByMonth";
import {
  filterEvents,
  getEventsByMonth,
} from "@circle-react/components/Events/NewEventsSpace/ListView/helpers";
import { ListViewItem } from "@circle-react/components/Events/NewEventsSpace/ListViewItem";
import { FeaturedEventItem } from "@circle-react/components/Events/NewEventsSpace/ListViewItem/FeaturedEventItem";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import type { Event } from "@circle-react/types";
import { Typography } from "@circle-react-uikit/Typography";

interface UpcomingEventsProps {
  events: Event[];
  isThumbnailView: boolean;
  onEventChange: (event: Event | number) => void;
  onEventDestroy: (id: number) => void;
}

export const UpcomingEvents = ({
  events,
  onEventDestroy,
  onEventChange,
  isThumbnailView,
}: UpcomingEventsProps) => {
  const { liveEvents, filteredEvents } = filterEvents(events, true);
  const eventsByMonth = getEventsByMonth(filteredEvents, "asc");

  const nextEvent = filteredEvents[0];
  const isLiveEventsAvailable = liveEvents.length > 0;

  const renderLiveIndicator = () => (
    <div className="flex h-[18px] w-[18px] items-center rounded-full bg-[#96F8B7]">
      <div className="m-auto h-[6px] w-[6px] rounded-full bg-[#008A2F]" />
    </div>
  );

  return (
    <>
      {isLiveEventsAvailable && (
        <div className="mb-9">
          <div className="mx-6 my-3 flex items-center space-x-4 md:mx-0">
            {renderLiveIndicator()}
            <Typography.TitleSm weight="bold">
              {t("events.now")}
            </Typography.TitleSm>
          </div>
          <div
            className={classNames(
              "border-primary bg-primary border-y sm:rounded-2xl sm:border",
            )}
            id="live-events-list"
          >
            {liveEvents.map(event => (
              <ListViewItem
                key={event.id}
                event={event}
                onRsvp={() => onEventChange(event)}
                onDestroy={() => onEventChange(event.id)}
                isThumbnailView={isThumbnailView}
              />
            ))}
          </div>
        </div>
      )}
      {nextEvent && (
        <FeaturedEventItem
          key={nextEvent.id}
          onRsvp={() => onEventChange(nextEvent)}
          onDestroy={() => onEventChange(nextEvent.id)}
          event={nextEvent}
          isThumbnailView={isThumbnailView}
          isNextEvent
        />
      )}
      <EventsListByMonth
        eventsByMonth={eventsByMonth}
        nextEvent={nextEvent}
        onEventDestroy={onEventDestroy}
        onEventChange={onEventChange}
        isThumbnailView={isThumbnailView}
      />
    </>
  );
};
